/* eslint-disable */
<template lang="html">
  <div style="margin-bottom: 300px">
    <div
      class="display-1 
                d-flex 
                justify-center 
                text-center
                mt-12
                pt-4
                grey--text 
                text--darken-2
                "
      v-text="name"
    ></div>
    <v-container class="my-5">
      <v-layout row>
        <v-card
          class="mx-auto 
                  mb-4
                  mt-2"
          max-width="344"
          v-for="(product, index) in products"
          :key="index"
        >
          <v-img v-bind:src="product.prodImgUrl" height="200px"></v-img>

          <v-card-title style="word-break: normal;" class="text-center">
            <span style="margin: 0 auto" v-text="product.prodName"> </span>
          </v-card-title>
        </v-card>
        <!-- ssss -->
      </v-layout>
    </v-container>
  </div>
</template>
<script>
export default {
  data: () => ({
    show: false,
    alignmentsAvailable: ["start", "center", "end", "baseline", "stretch"],
    alignment: "center",
    dense: false,
    justifyAvailable: [
      "start",
      "center",
      "end",
      "space-around",
      "space-between"
    ],
    justify: "center",
    name: "SASH Flagship-ის ზეთები ",
    text: "This is product",
    products: [
      {
        prodName: "FLAGSHIP DRACO SAE 0W-20, 4ლ",
        specification:
          "ACEA A3/B4, API: SN/SM/CF, ILSAC GF-5, Ford WSS-M2C930-A, Chrysler MS-6395.",
        prodImgUrl:
          "https://cdn5.vectorstock.com/i/1000x1000/82/89/eps-10-gold-olive-or-engine-oil-splash-3d-vector-24398289.jpg"
      }
    ]
  })
};
</script>
